// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/cell","rootFixed":"cell-m__rootFixed__1lXNB"};